import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { JVInput } from "../../shared/JVInput";
import { Fetch } from "../../shared/Fetch";
import { ILegalTaskType } from "./LegalTaskType";
import { EmptyTaskType } from "./Table";

interface Iprops {
  singleData: ILegalTaskType;
  open: boolean;
  hideDialog: () => void;
  toast: any;
  reload: boolean;
  setReload: (is: boolean) => void;
}

interface ITaskType {
  task_Id?: number;
  task_Type: string;
}

const Form = (props: Iprops) => {
  const [loading, setLoading] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<ITaskType>({
    defaultValues: {
      task_Type: "",
    },
  });

  useEffect(() => {
    if (props.open) {
      reset({
        task_Type: props.singleData?.task_Type || "",
      });
    }
  }, [props.open, props.singleData, reset]);

  const onSubmit = async (data: ITaskType) => {
    setLoading(true);

    const response = await Fetch("Legal_Task/TaskTypeForm", "POST", data, null, props.toast);

    if (response?.ok) {
      props.toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Task Type Added Successfully",
      });

      props.setReload(!props.reload);
      props.hideDialog();
      reset();
    }

    setLoading(false);
  };

  const onHide = () => {
    props.hideDialog();
    reset(EmptyTaskType);
  };

  return (
    <Dialog visible={props.open} onHide={props.hideDialog} header="Task Type" style={{ width: "40rem" }} >
      <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
        <JVInput required label="Task Name" control={control} name="task_Type" error={errors.task_Type?.message} />

        <div className="col-12 md:col-12 flex gap-4 justify-content-end">
          <Button style={{ width: "100px" }} label="SAVE" type="submit" loading={loading}></Button>
          <Button style={{ width: "100px" }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
        </div>
      </form>
    </Dialog>
  );
};

export default Form;
